import React from 'react';
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';

export const GapView: React.FC<NodeViewProps> = ({ node }) => {
  const description = String(node.attrs.description || '').trim() || 'Missing information';

  return (
    <NodeViewWrapper as="span" className="gap-wrapper">
      <span className="gap-badge">NEEDS INPUT: {description}</span>
    </NodeViewWrapper>
  );
};
